/** Textos do dialog "Configuração da Tabela" (decisão do usuário; Figma 4988:43954). */
export const TABLE_SETTINGS_TITLE = "Configuração da Tabela";
export const TABLE_SETTINGS_DENSITY_TITLE = "Tamanho da tabela";
export const TABLE_SETTINGS_COLUMNS_TITLE = "Mostrar e Ocultar Colunas";
export const TABLE_SETTINGS_APPLY_LABEL = "Aplicar";

export const DENSITY_COMFORTABLE_LABEL = "Confortável";
export const DENSITY_COMFORTABLE_DESCRIPTION =
  "Exibe as linhas com mais espaçamento, facilitando a leitura e diminuindo a fadiga visual.";
export const DENSITY_COMPACT_LABEL = "Compacto";
export const DENSITY_COMPACT_DESCRIPTION =
  "Reduz o espaçamento entre linhas para exibir mais registros simultaneamente por tela.";

/** Toasts do Figma 7238:34553 (sucesso e erro); a tela dispara no `onApplied`. */
export const TABLE_SETTINGS_APPLIED_MESSAGE = "Configurações da tabela atualizada com sucesso.";
export const TABLE_SETTINGS_ERROR_MESSAGE =
  "Não foi possível salvar as configurações da tabela. Tente novamente.";
/** Tooltip "colunas mínimas" (Figma 10892:56176): aparece na coluna principal, que não pode ser oculta. */
export const TABLE_SETTINGS_MIN_COLUMNS_TOOLTIP =
  "Não é possível ocultar colunas. A tabela já está exibindo o número mínimo necessário.";
